import { render, staticRenderFns } from "./Breakfast.vue?vue&type=template&id=b7486952&scoped=true&"
import script from "./Breakfast.vue?vue&type=script&lang=js&"
export * from "./Breakfast.vue?vue&type=script&lang=js&"
import style0 from "./Breakfast.vue?vue&type=style&index=0&id=b7486952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7486952",
  null
  
)

export default component.exports